<template>
  <div class="app flex-row align-items-center login-page">
    <div class="login-container">
      <!-- <v-icon class="card-image">$Pet</v-icon> -->
      <v-row class="justify-content-center">
        <v-col md="8" cols="12">
          <transition name="fade" mode="out-in">
            <v-card class="login-card" v-if="card == 'login'">
              <div>
                <h4 class="text-center mb-15 fs-xlarge">
                  به سامانه کتاب‌ باز خوش آمدید!
                </h4>

                <v-row>
                  <v-col class="text-center">
                    <div>
                      <v-text-field
                        append-icon="mdi-account"
                        placeholder="نام کاربری"
                        outlined
                        v-model="username"
                      ></v-text-field>
                      <v-text-field
                        append-icon="mdi-lock"
                        outlined
                        :prepend-inner-icon="
                          showPass ? 'mdi-eye' : 'mdi-eye-off'
                        "
                        :type="showPass ? 'text' : 'password'"
                        @click:prepend-inner="showPass = !showPass"
                        placeholder="رمز عبور"
                        v-model="password"
                        @keyup.enter="password && username ? login() : ''"
                      ></v-text-field>
                      <v-row>
                        <v-col>
                          <v-btn
                            :loading="busy"
                            @click="login()"
                            :disabled="busy || !(password && username)"
                            height="43"
                            class="orange-mainBtn w-100"
                            >ورود
                          </v-btn>
                        </v-col>
                      </v-row>
                      <div
                        class="d-flex grey--text text--darken-3 text-right mt-4"
                      >
                        هنوز حساب کاربری ایجاد نکرده‌اید؟
                        <div
                          class="underline-text primary--text font-weight-bold ms-1 pointer"
                          @click="card = 'signup'"
                        >
                          ثبت نام کنید
                        </div>
                        .
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card>
            <v-card class="login-card" v-if="card == 'signup'">
              <h4 class="text-center mb-5 fs-xlarge">ثبت نام</h4>
              <v-btn
                @click="card = 'login'"
                class="back-btn orange-borderedBtn"
              >
                <div style="transform: translateX(-3px)">
                  صفحه ورود
                  <v-icon style="margin-top: 3px">mdi-chevron-left</v-icon>
                </div>
              </v-btn>

              <div>
                <p class="text-center grey--text text--darken-1">
                  جهت ثبت نام و دریافت کد تایید شماره موبایل خود را وارد کنید:
                </p>
                <v-text-field
                  append-icon="mdi-cellphone"
                  placeholder="__ ___ ____"
                  outlined
                  type="number"
                  dir="ltr"
                  suffix="09"
                  autofocus
                  v-model="mobile"
                  :disabled="activationCode"
                  @keyup.enter="
                    mobile.length == 9 ? (activationCode = true) : ''
                  "
                ></v-text-field>
                <v-btn
                  :disabled="mobile.length != 9 || activationCode"
                  @click="activationCode = true"
                  class="orange-mainBtn w-100"
                  height="43"
                  >ارسال کد تایید</v-btn
                >
              </div>

              <div class="mt-12 text-center" v-if="activationCode">
                <b> کد تایید به شماره "{{ `09${mobile}` }}" ارسال شده است. </b>
                <p class="grey--text text--darken-2 mt-2">
                  کد ارسال شده را وارد کنید:
                </p>

                <PincodeInput
                  v-model="code"
                  class="center mb-6"
                  dir="ltr"
                  :class="incorrectCode ? 'incorrect-code' : ''"
                  :disabled="busy"
                  :length="4"
                  autofocus
                  @input="signup()"
                />

                <div
                  v-if="checkingCode"
                  class="d-flex justify-content-center primary--text mb-4"
                >
                  <half-circle-spinner
                    :animation-duration="1000"
                    :size="22"
                    color="#ef6c00"
                  />
                  <b class="ps-2 fs-xsmall"> در حال بررسی کد </b>
                </div>

                <div
                  v-if="incorrectCode"
                  class="d-flex justify-content-center error--text mb-4"
                >
                  <v-icon color="error">mdi-alert-circle-outline</v-icon>
                  <b class="ps-2 pt-1 fs-xsmall">
                    کد وارد شده صحیح نمی‌باشد. مجددا کد ارسال شده را وارد
                    نمایید.
                  </b>
                </div>

                <v-btn
                  @click="editMobileNumber()"
                  class="orange-mainBtn w-100"
                  height="43"
                  >ویرایش شماره موبایل</v-btn
                >
              </div>
            </v-card>
          </transition>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import md5 from "js-md5";
import PincodeInput from "vue-pincode-input";
import { LoopingRhombusesSpinner, HalfCircleSpinner } from "epic-spinners";

export default {
  components: {
    PincodeInput,
    HalfCircleSpinner,
  },
  data() {
    return {
      username: "",
      password: "",
      mobile: "",
      role: "",
      busy: false,
      showPass: false,
      card: "login",
      activationCode: false,
      incorrectCode: false,
      activationCode: false,
      checkingCode: false,
      countdown: 60,
      code: "",
    };
  },
  methods: {
    login() {
      this.busy = true;
      Axios.post(this.baseUrl + "/satrapp/auth/login", {
        username: this.username,
        password: md5(this.password),
      })
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            localStorage.clear();
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("role", res.data.role);
            localStorage.setItem("name", res.data.name);
            localStorage.setItem("userId", res.data.id);
            localStorage.setItem("mobile", this.username);
            // if (this.$route.query.return)
            //   this.$router.push(this.$route.query.return);
            // else this.$router.push("/" + res.data.role + "/dashboard");
            if (res.data.role != "sales") {
              this.$router.push("/" + res.data.role + "/dashboard");
            } else {
              this.$router.push("/sales/newInvoice");
            }
          } else {
            this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.busy = false;
          this.toast(err.response.data, "error");
        });
    },
    signup() {
      if (this.code.length == 4) {
        this.incorrectCode = false;
        this.checkingCode = true;
        setTimeout(() => {
          this.checkingCode = false;
          if (this.code == "1111") {
            this.incorrectCode = false;
          } else {
            this.incorrectCode = true;
            setTimeout(() => {
              this.code = "";
            }, 1000);
          }
        }, 2000);
      }

      this.incorrectCode = false;
      this.checkingCode = true;
      if (this.code.length == 4) {
        Axios.post(this.baseUrl + "/satrapp/auth/register", {
          mobile: `09${this.mobile}`,
          code: this.code,
        })
          .then((res) => {
            if (res.status == 200) {
              this.checkingCode = false;
              this.card = "form";
            } else {
              this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
            }
          })
          .catch((err) => {
            if (err.response && err.response.status == 401) {
              this.incorrectCode = true;
              setTimeout(() => {
                this.code = "";
                this.incorrectCode = false;
              }, 1000);
            }
            this.busy = false;
            this.toast(err.response.data, "error");
          });
      }
    },
    editMobileNumber() {
      this.activationCode = false;
      this.incorrectCode = false;
      this.checkingCode = false;
    },
  },
};
</script>
<style lang="scss">
.app {
  background-color: #f0f3ff;
}
.login-container {
  width: 70%;
}
@media only screen and (max-width: 600px) {
  .login-container {
    width: 90%;
    padding: 0;
  }
}
.login-page {
  background-image: url("/loginBg.jpg");
  background-position: center;
  background-size: cover;

  .login-card {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-52%, -50%);
    width: 45vw;
    margin: auto;
    border-radius: 20px !important;
    padding: 30px 25px;
    margin-bottom: 100px;
    max-height: 90vh;
    overflow-y: hidden;
    z-index: 10;
    &::-webkit-scrollbar {
      direction: rtl;
      width: 3px;
    }
    .v-input__icon.v-input__icon--prepend-inner {
      margin-left: 5px !important;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: unset;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background: grey;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: rgb(66, 66, 66);
    }
    .back-btn {
      position: absolute;
      left: 25px;
      top: 25px;
    }
    .v-input__slot {
      border-radius: 12px !important;
    }
  }
  @media only screen and (max-width: 1000px) {
    .login-card {
      width: 55vw !important;
    }
  }
  @media only screen and (max-width: 800px) {
    .login-card {
      width: 85vw !important;
      left: 55%;
      top: 50%;
    }
  }
  @media only screen and (max-width: 600px) {
    .login-card {
      width: 100% !important;
      left: 53%;
      top: 35%;
      padding: 30px 20px;
    }
  }
  .card-image {
    position: fixed;
    top: 50px;
    right: 53%;
    z-index: 100;
  }
  .underline-text {
    border-bottom: 1px solid #ef6c00;
    width: fit-content;
  }
}
</style>
